function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MastercardLogo = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("rect", {
    width: "1em",
    height: "1em",
    fill: "#fff",
    fillOpacity: ".01",
    rx: "6.667"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#FF5F00",
    d: "M25 30.833v-20H15v20h10Z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#F79E1B",
    d: "M40 20.833c0 6.91-5.533 12.5-12.371 12.5A12.215 12.215 0 0 1 20 30.66c2.887-2.292 4.708-5.834 4.708-9.827 0-3.993-1.856-7.534-4.708-9.826a12.216 12.216 0 0 1 7.629-2.674c6.838 0 12.371 5.625 12.371 12.5Z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#EB001B",
    d: "M15.292 20.833c0-3.993 1.856-7.534 4.708-9.826a12.216 12.216 0 0 0-7.629-2.674C5.533 8.333 0 13.923 0 20.833s5.533 12.5 12.371 12.5c2.887 0 5.533-1.007 7.629-2.673-2.852-2.257-4.708-5.834-4.708-9.827Z"
  })]
}));
MastercardLogo.displayName = 'MastercardLogo';
//# sourceMappingURL=MastercardLogo.js.map